// removed by extract-text-webpack-plugin
module.exports = {"modalText":"G134543"};